var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgLoginType2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1860_96144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.584961 13.1094L6.96306 16.2633V23.7364L6.72909 23.7037L0.584961 20.4234V13.1094Z",
    fill: "#E8EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.092 13.3047L6.97266 16.5148V21.8775L7.21599 23.7586L12.092 20.6187V13.3047Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51538 22.4549V19.9046L2.62488 18.9219L2.61084 21.4254L4.51538 22.4549Z",
    fill: "url(#paint0_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.62488 18.9219L2.95244 19.1091L2.90565 21.285L4.49666 22.1975L4.45455 22.4549L2.61084 21.4254L2.62488 18.9219Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71973 16.3828H7.2719V23.7436L6.71973 23.7249V16.3828Z",
    fill: "#DDDEE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30931 16.2139L6.7431 16.1671L0 12.475L0.210576 12.0024L5.32054 8.91866L6.06926 8.86719L12.7188 12.2879L12.8779 12.6388L7.30931 16.2139Z",
    fill: "#F6F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.692871 12.2186L5.33489 9.4764L6.00873 9.38281L12.1014 12.6116L11.8534 12.7707L6.00873 9.64486L5.36297 9.75249L1.04851 12.3777L0.692871 12.2186Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0463867 12.5234L6.74269 16.1687L6.78012 17.231L0.069784 13.5108L0.0463867 12.5234Z",
    fill: "#E8EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78072 16.2188H7.37033V17.2061L6.75732 17.2529L6.78072 16.2188Z",
    fill: "#DDDEE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34668 16.2906L12.8778 12.6406V13.6701L7.37008 17.2078L7.34668 16.2906Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12402 10.6094L19.7291 16.3557V29.9496L19.3032 29.8934L8.12402 23.9224V10.6094Z",
    fill: "#E8EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0642 10.9766L19.7427 16.8212V26.5779L20.1872 29.9986L29.0642 24.2849V10.9766Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7291 16.8268L8.12402 10.6125L16.9729 5.2358L18.1661 5.15625L29.0459 10.9822L19.7291 16.8268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17676 10.7215L16.9961 6.10287L18.0677 5.95312L27.7448 11.0865L27.3518 11.3392L18.063 6.3696L17.0382 6.54274L9.74765 10.9695L9.17676 10.7215Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4979 15.419V14.3333L14.3421 13.7344L14.3374 14.7919L15.4979 15.419Z",
    fill: "url(#paint1_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3421 13.7344L14.5433 13.8467L14.5152 14.703L15.4885 15.2599L15.4605 15.419L14.3374 14.7919L14.3421 13.7344Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8187 20.5674V19.4818L9.66288 18.8828L9.6582 19.9404L10.8187 20.5674Z",
    fill: "url(#paint2_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66288 18.8828L9.8641 18.9951L9.83602 19.8515L10.8093 20.4083L10.7813 20.5674L9.6582 19.9404L9.66288 18.8828Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7423 19.2315V18.1458L11.5865 17.5469L11.5771 18.6044L12.7423 19.2315Z",
    fill: "url(#paint3_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5865 17.5469L11.7877 17.6592L11.7596 18.5155L12.733 19.0771L12.7049 19.2315L11.5771 18.6044L11.5865 17.5469Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7545 20.3252V19.2396L13.5987 18.6406L13.5894 19.6982L14.7545 20.3252Z",
    fill: "url(#paint4_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5987 18.6406L13.7999 18.7529L13.7719 19.6093L14.7452 20.1661L14.7171 20.3252L13.5894 19.6982L13.5987 18.6406Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7423 17.3565V16.2708L11.5865 15.6719L11.5771 16.7294L12.7423 17.3565Z",
    fill: "url(#paint5_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5865 15.6719L11.7877 15.7842L11.7596 16.6405L12.733 17.2021L12.7049 17.3565L11.5771 16.7294L11.5865 15.6719Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8703 18.3018V17.2162L9.71444 16.6172L9.70508 17.6747L10.8703 18.3018Z",
    fill: "url(#paint6_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71444 16.6172L9.91565 16.7295L9.88758 17.5858L10.8609 18.1474L10.8328 18.3018L9.70508 17.6747L9.71444 16.6172Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8708 16.4268V15.3412L9.71493 14.7422L9.70557 15.7997L10.8708 16.4268Z",
    fill: "url(#paint7_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71493 14.7422L9.91614 14.8545L9.88806 15.7108L10.8614 16.2724L10.8333 16.4268L9.70557 15.7997L9.71493 14.7422Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25552 18.3018V17.2162L4.09969 16.6172L4.09033 17.6747L5.25552 18.3018Z",
    fill: "url(#paint8_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09969 16.6172L4.30091 16.7295L4.27283 17.5858L5.24616 18.1474L5.21808 18.3018L4.09033 17.6747L4.09969 16.6172Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.38345 17.3565V16.2708L2.22762 15.6719L2.21826 16.7294L3.38345 17.3565Z",
    fill: "url(#paint9_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.22762 15.6719L2.42884 15.7842L2.40076 16.6405L3.37409 17.2021L3.34601 17.3565L2.21826 16.7294L2.22762 15.6719Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7545 18.4659V17.3802L13.5987 16.7812L13.5894 17.8388L14.7545 18.4659Z",
    fill: "url(#paint10_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5987 16.7812L13.7999 16.8936L13.7719 17.7499L14.7452 18.3068L14.7171 18.4659L13.5894 17.8388L13.5987 16.7812Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8605 21.419V20.3333L15.7047 19.7344L15.6953 20.7966L16.8605 21.419Z",
    fill: "url(#paint11_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7047 19.7344L15.9059 19.8514L15.8778 20.7077L16.8511 21.2646L16.8231 21.419L15.6953 20.7966L15.7047 19.7344Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4979 13.5518V12.4662L14.3421 11.8672L14.3374 12.9247L15.4979 13.5518Z",
    fill: "url(#paint12_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3421 11.8672L14.5433 11.9795L14.5152 12.8358L15.4885 13.3927L15.4605 13.5518L14.3374 12.9247L14.3421 11.8672Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4215 14.5518V13.4662L16.2657 12.8672L16.2563 13.9247L17.4215 14.5518Z",
    fill: "url(#paint13_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2657 12.8672L16.4669 12.9795L16.4388 13.8358L17.4122 14.3974L17.3841 14.5518L16.2563 13.9247L16.2657 12.8672Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4333 15.6534V14.5677L18.2774 13.9688L18.2681 15.0263L19.4333 15.6534Z",
    fill: "url(#paint14_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2774 13.9688L18.4786 14.0811L18.4506 14.9374L19.4239 15.4943L19.3958 15.6534L18.2681 15.0263L18.2774 13.9688Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8605 19.5518V18.4662L15.7047 17.8672L15.6953 18.9294L16.8605 19.5518Z",
    fill: "url(#paint15_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7047 17.8672L15.9059 17.9842L15.8778 18.8405L16.8511 19.3974L16.8231 19.5518L15.6953 18.9294L15.7047 17.8672Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8605 23.7705V22.6849L15.7047 22.0859L15.6953 23.1482L16.8605 23.7705Z",
    fill: "url(#paint16_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7047 22.0859L15.9059 22.2029L15.8778 23.0593L16.8511 23.6161L16.8231 23.7705L15.6953 23.1482L15.7047 22.0859Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0379 18.2736L27.0005 17.188L28.1329 16.5469L28.1797 17.6044L27.0379 18.2736Z",
    fill: "url(#paint17_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1325 16.5469L27.936 16.6685L27.9968 17.5249L27.0469 18.1192L27.0796 18.2736L28.1793 17.6044L28.1325 16.5469Z",
    fill: "#A7ABB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0846 20.5705L27.0425 19.4848L28.1749 18.8438L28.2264 19.9013L27.0846 20.5705Z",
    fill: "url(#paint18_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1745 18.8438L27.978 18.9607L28.0388 19.8171L27.0889 20.4114L27.1216 20.5658L28.226 19.9013L28.1745 18.8438Z",
    fill: "#A7ABB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0584 19.4455L25.021 18.3598L26.1534 17.7188L26.2002 18.7763L25.0584 19.4455Z",
    fill: "url(#paint19_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1533 17.7188L25.9521 17.8404L26.0129 18.6968L25.063 19.2864L25.1004 19.4455L26.2001 18.7763L26.1533 17.7188Z",
    fill: "#A7ABB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1163 20.6486L23.0742 19.563L24.2066 18.9219L24.2534 19.9794L23.1163 20.6486Z",
    fill: "url(#paint20_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2062 18.9219L24.0097 19.0435L24.0705 19.8999L23.1206 20.4942L23.1534 20.6486L24.253 19.9794L24.2062 18.9219Z",
    fill: "#A7ABB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1149 21.7345L25.0728 20.6489L26.2052 20.0078L26.2567 21.0654L25.1149 21.7345Z",
    fill: "url(#paint21_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2048 20.0078L26.0082 20.1295L26.0691 20.9858L25.1191 21.5754L25.1519 21.7345L26.2562 21.0654L26.2048 20.0078Z",
    fill: "#A7ABB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1163 22.9017L23.0742 21.8208L24.2066 21.1797L24.2534 22.2372L23.1163 22.9017Z",
    fill: "url(#paint22_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2062 21.1797L24.0097 21.2967L24.0705 22.153L23.1206 22.7473L23.1534 22.9017L24.253 22.2372L24.2062 21.1797Z",
    fill: "#A7ABB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0535 21.8283L21.0161 20.7426L22.1485 20.1016L22.1953 21.1591L21.0535 21.8283Z",
    fill: "url(#paint23_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1484 20.1016L21.9472 20.2232L22.008 21.0796L21.0581 21.6739L21.0955 21.8283L22.1952 21.1591L22.1484 20.1016Z",
    fill: "#A7ABB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0379 15.9298L27.0005 14.8442L28.1329 14.2031L28.1797 15.2607L27.0379 15.9298Z",
    fill: "url(#paint24_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1325 14.2031L27.936 14.3248L27.9968 15.1811L27.0469 15.7754L27.0796 15.9298L28.1793 15.2607L28.1325 14.2031Z",
    fill: "#A7ABB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1285 17.1564L25.0864 16.0708L26.2189 15.4297L26.2703 16.4872L25.1285 17.1564Z",
    fill: "url(#paint25_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2184 15.4297L26.0219 15.5514L26.0827 16.4077L25.1328 16.9973L25.1656 17.1564L26.2699 16.4872L26.2184 15.4297Z",
    fill: "#A7ABB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1588 18.3986L23.1167 17.313L24.2491 16.6719L24.2959 17.7294L23.1588 18.3986Z",
    fill: "url(#paint26_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2487 16.6719L24.0522 16.7935L24.113 17.6499L23.1631 18.2442L23.1958 18.3986L24.2955 17.7294L24.2487 16.6719Z",
    fill: "#A7ABB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0812 19.5939L21.0391 18.5083L22.1715 17.8672L22.223 18.9247L21.0812 19.5939Z",
    fill: "url(#paint27_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1711 17.8672L21.9745 17.9889L22.0354 18.8452L21.0854 19.4348L21.1182 19.5939L22.2226 18.9247L22.1711 17.8672Z",
    fill: "#A7ABB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1139 24.0705L21.0718 22.9848L22.2042 22.3438L22.251 23.4013L21.1139 24.0705Z",
    fill: "url(#paint28_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2038 22.3438L22.0073 22.4654L22.0681 23.3218L21.1182 23.916L21.1509 24.0705L22.2506 23.4013L22.2038 22.3438Z",
    fill: "#A7ABB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9228 27.4718V22.8297L11.4788 21.0469L11.4507 25.6047L14.9228 27.4718Z",
    fill: "url(#paint29_linear_1860_96144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4788 21.0469L12.0777 21.3838L11.9935 25.3426L14.8901 27.0038L14.8059 27.4718L11.4507 25.6047L11.4788 21.0469Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2886 16.575L20.2947 16.5703V29.9723L19.2886 29.9395V16.575Z",
    fill: "#DDDEE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.365 16.2598L19.3309 16.1756L7.05664 9.45122L7.44504 8.59488L16.7384 2.98421L18.1048 2.89062L30.2106 9.11898L30.496 9.75071L20.365 16.2598Z",
    fill: "#F6F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31543 8.97862L16.7665 3.98096L17.9925 3.8125L29.0829 9.69458L28.6336 9.9847L17.9925 4.2898L16.818 4.48634L8.97055 9.26407L8.31543 8.97862Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14062 9.53906L19.3306 16.1792L19.3961 18.1118L7.18742 11.3407L7.14062 9.53906Z",
    fill: "#E8EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3966 16.2656H20.4682V18.0672L19.3545 18.1514L19.3966 16.2656Z",
    fill: "#DDDEE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4258 16.3948L30.496 9.75V11.6218L20.4679 18.0654L20.4258 16.3948Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8052 3.75781L11.5211 4.02922L11.4603 12.3399L10.8754 11.9749L10.8052 3.75781Z",
    fill: "#E8EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0126 3.58716L11.4698 3.39062L10.8428 3.75562L11.5213 4.02703L12.0126 3.63396V3.58716Z",
    fill: "#F6F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5213 4.02589L11.4604 12.3366L11.9752 11.878L12.0126 3.63281L11.5213 4.02589Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4658 6.3125L16.1818 6.57923L16.1209 14.8899L15.536 14.5249L15.4658 6.3125Z",
    fill: "#E8EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6733 6.14185L16.1305 5.94531L15.5034 6.31499L16.1819 6.58172L16.6733 6.18864V6.14185Z",
    fill: "#F6F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1819 6.58057L16.1211 14.8913L16.6358 14.4327L16.6733 6.1875L16.1819 6.58057Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.68213 0.3125L17.7869 4.55677L17.7261 12.8675L9.75232 8.52963L9.68213 0.3125Z",
    fill: "#E8EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6149 4.01497L10.9593 0L9.71924 0.313524L17.7866 4.55779V4.56247L18.6149 4.06645V4.01497Z",
    fill: "#F6F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7874 4.55852L17.7266 12.8646L18.5829 12.3077L18.6157 4.0625L17.7874 4.55852Z",
    fill: "#C8CBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9184 10.1173L14.0387 10.0612L12.939 8.95683L12.1528 2.92969L13.0373 2.99052L14.8482 4.04808L14.9184 10.1173Z",
    fill: "#007238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3232 4.10771L11.1 4.04688L16.9634 6.9107L16.8932 9.36274L16.0415 9.35338L11.1 6.36789L10.3232 4.10771Z",
    fill: "#007238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0663 10.1157L12.0869 8.9552V2.89062L13.9961 4.04645L14.0663 10.1157Z",
    fill: "#009842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2485 4.04688L16.1119 6.9107L16.0417 9.36274L10.2485 6.36789V4.04688Z",
    fill: "#009842"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1860_96144",
    x1: -6.1959,
    y1: 7.95791,
    x2: 20.215,
    y2: 42.3426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1860_96144",
    x1: 13.6682,
    y1: 12.9342,
    x2: 27.3042,
    y2: 30.6927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1860_96144",
    x1: 8.98904,
    y1: 18.0826,
    x2: 22.625,
    y2: 35.8412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1860_96144",
    x1: 9.71005,
    y1: 15.1884,
    x2: 23.346,
    y2: 32.9376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1860_96144",
    x1: 10.4448,
    y1: 14.6163,
    x2: 24.0854,
    y2: 32.3702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1860_96144",
    x1: 9.71005,
    y1: 13.3134,
    x2: 23.346,
    y2: 31.0626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1860_96144",
    x1: 7.83797,
    y1: 14.2587,
    x2: 21.4739,
    y2: 32.0079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1860_96144",
    x1: 7.83846,
    y1: 12.3837,
    x2: 21.4744,
    y2: 30.1329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1860_96144",
    x1: 2.22323,
    y1: 14.2587,
    x2: 15.8592,
    y2: 32.0079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1860_96144",
    x1: 0.351158,
    y1: 13.3134,
    x2: 13.9871,
    y2: 31.0626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1860_96144",
    x1: 10.4448,
    y1: 12.7569,
    x2: 24.0854,
    y2: 30.5108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1860_96144",
    x1: 11.2405,
    y1: 14.0067,
    x2: 24.8717,
    y2: 31.7559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1860_96144",
    x1: 13.6682,
    y1: 11.067,
    x2: 27.3042,
    y2: 28.8255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1860_96144",
    x1: 14.3892,
    y1: 10.5087,
    x2: 28.0252,
    y2: 28.2579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1860_96144",
    x1: 15.1235,
    y1: 9.94442,
    x2: 28.7641,
    y2: 27.6983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1860_96144",
    x1: 11.2405,
    y1: 12.1395,
    x2: 24.8717,
    y2: 29.8887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1860_96144",
    x1: 11.2405,
    y1: 16.3583,
    x2: 24.8717,
    y2: 34.1075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1860_96144",
    x1: 28.7777,
    y1: 15.7256,
    x2: 15.811,
    y2: 33.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1860_96144",
    x1: 28.821,
    y1: 18.0225,
    x2: 15.8542,
    y2: 36.2662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1860_96144",
    x1: 27.9375,
    y1: 15.2906,
    x2: 14.971,
    y2: 33.5437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1860_96144",
    x1: 27.2113,
    y1: 14.7843,
    x2: 14.2401,
    y2: 33.0376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1860_96144",
    x1: 27.9946,
    y1: 17.5792,
    x2: 15.0235,
    y2: 35.8324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1860_96144",
    x1: 27.211,
    y1: 17.039,
    x2: 14.2398,
    y2: 35.2923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1860_96144",
    x1: 26.3946,
    y1: 14.2111,
    x2: 13.4279,
    y2: 32.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1860_96144",
    x1: 28.7796,
    y1: 13.3802,
    x2: 15.8084,
    y2: 31.6335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1860_96144",
    x1: 28.0064,
    y1: 13.0021,
    x2: 15.0397,
    y2: 31.2505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1860_96144",
    x1: 27.2499,
    y1: 12.536,
    x2: 14.2834,
    y2: 30.7891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1860_96144",
    x1: 26.4189,
    y1: 11.9743,
    x2: 13.4569,
    y2: 30.2225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1860_96144",
    x1: 26.45,
    y1: 16.4575,
    x2: 13.4877,
    y2: 34.6963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1860_96144",
    x1: -4.58114,
    y1: 1.08431,
    x2: 43.4909,
    y2: 63.6721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1860_96144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.496,
    height: 30,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLoginType2);
export default __webpack_public_path__ + "static/media/img_login_type2.f5079afc6830b5a784cd63a9d4b7bbb6.svg";
export { ForwardRef as ReactComponent };